import axios from "axios";
import { Base_URL } from "../url";

export const fetchHSNData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/HSN/HsnGetData`);
    return response.data;
  } catch (error) {
    console.error("HSN API Fetch Error:", error);
    throw error.response?.data || "Failed to fetch HSN data";
  }
};

export const downloadHSNExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/HSN/DownloadHsnExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    console.error("HSN Download Error:", error);
    throw error.response?.data || "Failed to download HSN data";
  }
};